// extracted by mini-css-extract-plugin
module.exports = {"headline":"member-operations__Headline__headline"};